import { tradeRequestsState } from './tradeRequests.state';
import { tradeRequestsActions } from './tradeRequests.actions';
import { tradeRequestsGetters } from './tradeRequests.getters';
import { tradeRequestsMutations } from './tradeRequests.mutations';

export default {
  state: tradeRequestsState,
  actions: tradeRequestsActions,
  getters: tradeRequestsGetters,
  mutations: tradeRequestsMutations,
};
